import React from 'react';
import thunk from 'redux-thunk';
import { darkBaseTheme, MuiThemeProvider } from 'material-ui/styles';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import reducers from './app/shared/reducers';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'react-router-redux';
import HttpsRedirect from 'react-https-redirect';
import { DashboardStorageManagerInstance } from './app/dashboard/DashboardStorageManager';
import cookie from 'react-cookies';
import { AUTH_TOKEN } from './app/shared/utils/CookiesManager';
import { AuthRouting } from './app/shared/routing/AuthRouting';
import { NoAuthRouting } from './app/shared/routing/NoAuthRouting';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/genie.css';

class App extends React.Component {

    componentDidMount() {
        DashboardStorageManagerInstance.init();
    }

    render() {
        const history = createBrowserHistory();
        history.listen(() => {
            window.scrollTo(0, 0);
        })

        // Build the middleware for intercepting and dispatching navigation actions
        const middleware = routerMiddleware(history);
        const store = createStore(reducers, applyMiddleware(thunk, middleware));
        const authToken = cookie.load(AUTH_TOKEN);

        return (
            <React.StrictMode>
                <HttpsRedirect>
                    <Provider store={store}>
                        <MuiThemeProvider theme={darkBaseTheme}>
                            {
                                authToken
                                    ? <AuthRouting history={history}/>
                                    : <NoAuthRouting history={history}/>
                            }
                        </MuiThemeProvider>
                    </Provider>
                </HttpsRedirect>
            </React.StrictMode>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js